<template>
  <div class="breadcrumb ft16">
    <span class="flag"></span>
    <div class="navt">
      <slot class="parentsMenu" name="parentsMenu"></slot>
    </div>
    <div class="navt">
      <slot name="breadcrumb"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["parentsMenu", "separator", "currentMenu"],
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.breadcrumb {
  height: 36px;
  line-height: 36px;
  color: #787878;
  font-weight: 600;
  border: 0.1px solid white;
  background: #ffffff;
  border-bottom: 1px solid rgba(230, 230, 230, 0.5);
  // box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
  .flag {
    float: left;
    width: 4px;
    height: 20px;
    background-color: #e88078;
    margin-right: 20px;
    margin-top: 7px;
  }
  .separator {
    margin: 0 7px;
  }
  .navt {
    float: left;
    .el-breadcrumb {
      font-size: 16px;
      line-height: 36px;
    }
    .el-breadcrumb__inner {
      color: #e88078;
      font-weight: 600;
    }
    .is-link {
      color: #787878;
    }
  }
}
</style>
